import {createSelector} from 'reselect';
import {combineReducers, AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';

import megatron from '@stencil/megatron';

// ! move prepareCommonUserWidget to API
// ! should split out and have multiple imports for usage
// ! e.g. - @stencil/user-reducer/selectors or /actions likewise

export interface IUserStoreState {
  userInfo: IUserInfo;
  gocashInfo: IGocashInfo;
  isLoading: boolean;
  showLoginPopup: boolean;
  isLoggedIn: boolean;
}

export interface IUserInfo {
  first_name?: string;
  last_name?: string;
  email?: string;
  userid: number;
  profile_type?: string;
  image_url?: string;
  hashedemail?: string;
}

export interface IGocashInfo {
  success: boolean;
  data: {
    credits_id?: string;
    np_amt?: number;
    p_amt?: number;
    is_locked?: number;
    b_amt?: number;
    t_amt?: number;
  };
}

export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const TOGGLE_LOADING_USER_DETAILS = 'TOGGLE_LOADING_USER_DETAILS';
export const TOGGLE_LOGIN_POPUP = 'TOGGLE_LOGIN_POPUP';

export interface IUpdateUserDetails {
  type: typeof UPDATE_USER_DETAILS;
  actionData: {
    userInfo: IUserStoreState['userInfo'];
    gocashInfo: IUserStoreState['gocashInfo'];
    isLoggedIn: IUserStoreState['isLoggedIn'];
  };
}

export interface IToggleLoadingUserDetails {
  type: typeof TOGGLE_LOADING_USER_DETAILS;
  actionData: IUserStoreState['isLoading'];
}

export interface IToggleLoginPopup {
  type: typeof TOGGLE_LOGIN_POPUP;
  actionData: IUserStoreState['showLoginPopup'];
}

export type IUserActionTypes = IUpdateUserDetails | IToggleLoadingUserDetails | IToggleLoginPopup;

export function updateUserDetailsAction(
  actionData: IUpdateUserDetails['actionData'],
): IUpdateUserDetails {
  return {
    type: UPDATE_USER_DETAILS,
    actionData,
  };
}

export function toggleLoadingUserDetailsAction(
  actionData: IToggleLoadingUserDetails['actionData'],
): IToggleLoadingUserDetails {
  return {
    type: TOGGLE_LOADING_USER_DETAILS,
    actionData,
  };
}

export function toggleLoginPopup(actionData: IToggleLoginPopup['actionData']): IToggleLoginPopup {
  return {
    type: TOGGLE_LOGIN_POPUP,
    actionData,
  };
}

// ! move to api
export function prepareCommonUserWidgetRequest() {
  return `/common/userwidget/?random=+${Math.random()}`;
}

export const fetchUserDetailsThunk = (): ThunkAction<void, UserAppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<UserAppState, {}, AnyAction>, getState: () => UserAppState) => {
    dispatch(toggleLoadingUserDetailsAction(true));

    const url = prepareCommonUserWidgetRequest();

    megatron({
      name: 'common userwidget api',
      type: 'GET',
      url,
    })
      .then((response: {gocashInfo: IGocashInfo; userinfo: IUserInfo}) => {
        // const gocashInfo = (response && response.gocashInfo) || null;
        // const userInfo = (response && response.userinfo) || {
        //   profile_type: 'personal',
        //   userid: null,
        // };
        dispatch(toggleLoadingUserDetailsAction(false));

        if (response.updateUser && response.updateUser.indexOf('logoutuser') >= 0) {
          const userSigninCta = document.getElementById('hdr_user_signin');
          if (userSigninCta) {
            userSigninCta.classList.add('dn');
            userSigninCta.classList.remove('dib');
          }
          const hd_user_widdget = document.getElementById('hd_user_widdget');
          if (hd_user_widdget) hd_user_widdget.innerHTML = response.updateUser;

          const gocash = response.gocashInfo ? response.gocashInfo : {};
          window.userInfo = response.userinfo;
          window.gocashInfo = response.gocashInfo ? response.gocashInfo : {};
          dispatch(
            updateUserDetailsAction({
              gocashInfo: gocash,
              userInfo: response.userinfo,
              isLoggedIn: userInfo && userInfo.userid ? true : false,
            }),
          );
        } else {
          dispatch(
            updateUserDetailsAction({
              gocashInfo: {data: null},
              userInfo: {},
              isLoggedIn: false,
            }),
          );
        }
      })
      .catch(err => {
        // ! do something for error case
        dispatch(toggleLoadingUserDetailsAction(false));
        // dispatch(updateHasDataAction(false));
      });
    // }
  };
};

const initialState: IUserStoreState = {
  isLoading: false,
  userInfo: {profile_type: 'personal', userid: null},
  gocashInfo: null,
  isLoggedIn: false,
  showLoginPopup: false,
};

export function userDetailsReducer(state = initialState, action: IUserActionTypes) {
  switch (action.type) {
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        ...action.actionData,
      };

    case TOGGLE_LOADING_USER_DETAILS:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case TOGGLE_LOGIN_POPUP:
      return {
        ...state,
        showLoginPopup: action.actionData,
      };

    default:
      return state;
  }
}

export const userReducer = {
  user: userDetailsReducer,
};

export const userSelector = createSelector(
  (state: UserAppState) => state.user,
  item => item,
);

const rootReducer = combineReducers(userReducer);

export type UserAppState = ReturnType<typeof rootReducer>;
